import {Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {TaxSummary} from '../../../../../../../../../api';
import {ElciaButton} from '../../../../../../../../components/buttons/button/button';
import {Loader} from '../../../../../../../../components/loader/loader';

@Component({
  selector: 'elcia-accounting-tax-grid',
  imports: [TableModule, TranslatePipe, ElciaButton, Loader],
  templateUrl: './accounting-tax-grid.html',
})
export class AccountingTaxGrid {
  taxes = input<TaxSummary[]>([]);
  isLoading = input<boolean>(false);
  onEdit = output<TaxSummary>();
  onDelete = output<TaxSummary>();

  protected edit(row: TaxSummary): void {
    this.onEdit.emit(row);
  }

  protected delete(event: Event, row: TaxSummary): void {
    event.stopPropagation();
    this.onDelete.emit(row);
  }
}
